export default class Constants {
    static readonly VERSION_NO = "v1.5.9"; // Version number of the application, shown in the tooltip of the app title. Should match the release tag in GitHub

    static readonly POINT_EQ_TOLERANCE = 0.001; // Equality tolerance when comparing x&y of two points together
    static readonly UPDATE_GEOMETRY_POINT_EQ_TOLERANCE = 0.001; // Tolerance for change that triggers geometry update
    static readonly INPUT_COMMAND_IS_PARALLEL_TOLERANCE = 0.01;

    static readonly IO_LOCATION_PRECISION = 3; // Precision for location vectors in IO operations
    static readonly IO_DIRECTION_PRECISION = 5; // Precision for direction vectors in IO operations

    static readonly DEFAULT_EXTRUSION_DEPTH_MM = 2; // Fixed extrusion height used by the shape annotation tools (Polygon/Rectangle/Circle)
    static readonly MIN_EXTRUSION_DEPTH_MM = 1; // Floor enforced when dragging an annotation's extrusion-depth edit handle

    // How close a surface normal's dot product with world Z must be to count as "horizontal"
    // (floor/ceiling) rather than "vertical enough that world Z is a meaningful up reference"
    // (a wall, or any sufficiently tilted surface). Used both when a shape is first drawn
    // (AddExtrudedLoopAnnotationCmd.deriveRefDirection(), to pick the profile's local axes) and
    // when rendering its area-label rotation (ExtrudedLoopSubGeometryBase.updateAreaLabelRotation())
    // — these two MUST stay in sync, or a surface classified as "wall" at creation time can be
    // misclassified as "floor" at render time (or vice versa), producing a label rotated 90° off.
    static readonly HORIZONTAL_SURFACE_DOT_THRESHOLD = 0.99;

    // If there is more of these, they probably deserve their own file
    static readonly UI_CROSSHAIR_ID = "pti-crosshair"; // PTI = Precision Touch Input
}
